module.exports = __webpack_public_path__ + "img/skredhendelser.cfbf62fb.jpg";